import axios from "axios";

export const submitHomework = (homework, success, failure) => {
    const url = `/api/v1/homework/`;

    axios.post(url, {
        course: homework.course,
        submissions: homework.submissions,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};
